/**
 * Keys removed from `forms[formType].data` when the user selects a different
 * connector in `useFlowsSetup.onSelectConnection`. Keeps REST/API probe state,
 * templated API fields, and credential-adjacent leftovers from leaking across
 * connector types in the same wizard session.
 */
export const CONNECTION_CHANGE_RESET_FORM_FIELDS: string[] = [
  // Also read as formData.selectedCredential._vendorConnectionType in useStartSink.ts —
  // keep this key even though selectedCredentialInfo (below) is the one useFlowsSetup reads.
  'selectedCredential',
  'selectedCredentialInfo',
  'sinkConfig',
  'sourceConfig',
  'selectedBucket',
  'selectedTable',
  'table',
  'isNewTable',
  'credentialId',
  'addedCredentialId',
  'discoveryResults',
  'selectedFeeds',
  'feedFields',
  'feedFieldsLoading',
  'expandedFeeds',
  'vendorFeedSpecs',
  'availableFeeds',
  'templateVersionInfo',
  'apiConfig',
  'apiResponseByStage',
  'apiResponseUpdateTime',
  'connectionAuthFields',
  'dataPathValidationResultByStage',
  'scriptCredentialsData',
  'selectedTemplate',
  'templatizedAPIConfig',
  'templatizedScriptConfig',
];
